import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

// Enums phải đồng bộ với backend (modules/ad-slot/*.entity.ts)
export enum BannerPosition {
    HEADER = 'header',
    SIDEBAR = 'sidebar',
    FOOTER = 'footer',
    IN_ARTICLE = 'in_article',
    POPUP = 'popup',
    FLOAT_LEFT = 'float_left',
    FLOAT_RIGHT = 'float_right',
    CATFISH = 'catfish',
    PREROLL = 'preroll',
    CLICKUNDER = 'clickunder',
}

export enum TextLinkPosition {
    HEADER = 'header',
    FOOTER = 'footer',
    SIDEBAR = 'sidebar',
    IN_ARTICLE = 'in_article',
}

export const BANNER_POSITION_LABEL: Record<BannerPosition, string> = {
    [BannerPosition.HEADER]: 'Đầu trang',
    [BannerPosition.SIDEBAR]: 'Cột bên',
    [BannerPosition.FOOTER]: 'Chân trang',
    [BannerPosition.IN_ARTICLE]: 'Trong bài viết',
    [BannerPosition.POPUP]: 'Cửa sổ bật lên',
    [BannerPosition.FLOAT_LEFT]: 'Nổi bên trái',
    [BannerPosition.FLOAT_RIGHT]: 'Nổi bên phải',
    [BannerPosition.CATFISH]: 'Catfish (dính đáy)',
    [BannerPosition.PREROLL]: 'Pre-roll (video trước phim)',
    [BannerPosition.CLICKUNDER]: 'Clickunder (mở tab nền)',
};

export const TEXTLINK_POSITION_LABEL: Record<TextLinkPosition, string> = {
    [TextLinkPosition.HEADER]: 'Đầu trang',
    [TextLinkPosition.FOOTER]: 'Chân trang',
    [TextLinkPosition.SIDEBAR]: 'Cột bên',
    [TextLinkPosition.IN_ARTICLE]: 'Trong bài viết',
};

export interface Banner {
    _id: string;
    name: string;
    imageUrl: string;
    targetUrl: string;
    alt?: string;
    position: BannerPosition;
    order: number;
    isActive: boolean;
    startAt?: string | null;
    endAt?: string | null;
    note?: string;
    /** Site nào hiện banner này — xem ghi chú ở banner.entity.ts. */
    domains: string[];
    createdAt?: string;
    updatedAt?: string;
}

export interface TextLink {
    _id: string;
    anchor: string;
    url: string;
    rel: string;
    target: string;
    position: TextLinkPosition;
    order: number;
    isActive: boolean;
    startAt?: string | null;
    endAt?: string | null;
    note?: string;
    /** Site nào hiện textlink này — xem ghi chú ở textlink.entity.ts. */
    domains: string[];
    createdAt?: string;
    updatedAt?: string;
}

export type CreateBannerDto = Omit<Banner, '_id' | 'createdAt' | 'updatedAt'>;
export type UpdateBannerDto = Partial<CreateBannerDto>;
export type CreateTextLinkDto = Omit<TextLink, '_id' | 'createdAt' | 'updatedAt'>;
export type UpdateTextLinkDto = Partial<CreateTextLinkDto>;

const ENDPOINTS = {
    BANNERS: '/ad-slots/banners',
    BANNER_BY_ID: (id: string) => `/ad-slots/banners/${id}`,
    TEXTLINKS: '/ad-slots/textlinks',
    TEXTLINK_BY_ID: (id: string) => `/ad-slots/textlinks/${id}`,
};

export const adSlotService = {
    getBanners(): Promise<ApiResponse<any>> {
        return apiClient.get(ENDPOINTS.BANNERS);
    },
    createBanner(data: CreateBannerDto): Promise<ApiResponse<any>> {
        return apiClient.post(ENDPOINTS.BANNERS, data as any);
    },
    updateBanner(id: string, data: UpdateBannerDto): Promise<ApiResponse<any>> {
        return apiClient.put(ENDPOINTS.BANNER_BY_ID(id), data as any);
    },
    removeBanner(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(ENDPOINTS.BANNER_BY_ID(id));
    },

    getTextLinks(): Promise<ApiResponse<any>> {
        return apiClient.get(ENDPOINTS.TEXTLINKS);
    },
    createTextLink(data: CreateTextLinkDto): Promise<ApiResponse<any>> {
        return apiClient.post(ENDPOINTS.TEXTLINKS, data as any);
    },
    updateTextLink(id: string, data: UpdateTextLinkDto): Promise<ApiResponse<any>> {
        return apiClient.put(ENDPOINTS.TEXTLINK_BY_ID(id), data as any);
    },
    removeTextLink(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(ENDPOINTS.TEXTLINK_BY_ID(id));
    },
};
